import { Link } from "@tanstack/react-router";

/**
 * Finendra brand mark — a geometric "F" (ledger stem + arms) set in a navy tile,
 * with the mid arm in brand accent to signal upward movement.
 */
export function LogoMark({ className = "size-8" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      role="img"
      aria-label="Finendra"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="7.5" className="fill-brand-navy" />
      <rect x="7" y="6" width="19" height="5" rx="1.4" className="fill-background" />
      <rect x="7" y="6" width="5" height="20" rx="1.4" className="fill-background" />
      <rect x="13.4" y="14" width="9.2" height="5" rx="1.4" className="fill-brand-accent" />
    </svg>
  );
}

export function Logo({
  className = "",
  markClassName = "size-8",
  wordClassName = "text-xl",
  onClick,
}: {
  className?: string;
  markClassName?: string;
  wordClassName?: string;
  onClick?: () => void;
}) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} onClick={onClick}>
      <LogoMark className={markClassName} />
      <span
        className={`font-display font-extrabold tracking-tight text-brand-navy ${wordClassName}`}
      >
        FINENDRA
      </span>
    </Link>
  );
}
